//relate to reapply and main forms
import {useLoading} from "vue-loading-overlay";
import axios from "axios";
import {countClick, handleGetParams, logIPQSCommon, sendVisitorActionTypeRequest} from "./commonGeneral";

export async function mountedCommonForm(vue, fromReapply = 0) {

    if (globalParams.request_id) {
        checkDecisionByRequestId(vue); //if cookie request_id exist customer wasn't redirected
    }
    await handleGetParams(vue);
    await countClick(vue, fromReapply);
    await sendVisitorActionTypeRequest(vue);

    window.addEventListener('online', () => {
        setTimeout(vue.$toast.clear, 100);
        vue.network = true;
    });
    window.addEventListener('offline', () => {
        vue.$toast.error("Internet connection lost.");
        vue.network = false;
    });

    await axios.get(import.meta.env.VITE_API_GET_USER).then((response) => {
        if (response.data.personal_min_req) {
            vue.personal_min_req = response.data.personal_min_req;
        } else {
            vue.personal_min_req = 1500;
        }
        if (response.data.post_back_amount) {
            vue.post_back_amount = response.data.post_back_amount;
        } else {
            vue.post_back_amount = 500;
        }
        vue.requestedAmountWatcher();
    }).catch((error) => {
        console.error(error);
    });

    if (window.isSharedCookie === 0) {
        document.addEventListener('fingerPrintFinished', (e) => {
            vue.handleFingerPrintFinished(e);
        });
    }
}

export function handleFingerPrintFinished(e) {
    const result = e.detail;
    globalParams.end_ipqs_request = Date.now();
    globalParams.duration_ipqs_requst = (globalParams.end_ipqs_request - globalParams.started_ipqs_request) / 1000;
    globalParams.device_id = result.device_id
    this.fields.risk_finger_print = result.fraud_chance;
    this.fields.risk_processed_finger_print = 1;
    this.fields.is_crawler = result.is_crawler;
    this.fields.risk = globalParams.risk ?? this.$cookies.get('risk');
    this.fields.risk_processed = globalParams.risk_processed ?? this.$cookies.get('risk_processed');

    logIPQSCommon({
        device_id_in_cookie: false,
        device_id: result.device_id,
        found_in_redis: false,
        source: 'submit',
        trigger_ipqs: true,
        risk_finger_print: result.fraud_chance,
        is_crawler: result.is_crawler,
        risk_processed_finger_print: 1,
    });
}

export async function nextPayDayWatcher() {
    if (this.fields.next_pay_day !== '' && this.fields.next_pay_day != null && this.fields.pay_frequency !== '' && this.fields.pay_frequency != null && !globalParams.aid_verified) {

        try {
            const response = await axios.get(import.meta.env.VITE_API_GET_PAY_DAY, {
                params: {
                    'next_pay_day': this.fields.next_pay_day,
                    'pay_frequency': this.fields.pay_frequency
                }
            });
            this.fields.second_pay_day = response.data.second_pay_day;
        } catch (error) {
            console.error(error);
        }
    }
}

export function getDateInPacificTimezone(offsetYears = 0) {
    let timezone = window.timeZone
    const now = new Date()
    const options = {timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit'}
    const pacificDateStr = now.toLocaleDateString('en-US', options)

    const [month, day, year] = pacificDateStr.split('/')
    const date = new Date(`${year}-${month}-${day}`)

    if (offsetYears) {
        date.setFullYear(date.getFullYear() - offsetYears)
    }

    return date
}

export async function routingNumberWatcher() {
    this.v$.fields.routing_number.$touch();
    if (this.v$.fields.routing_number.$error) {
        return false;
    }
    this.fields.bank_name = null;
    this.fields.bank_phone = null;
    document.getElementById('invalid-routing_number').classList.add('d-none');
    let useLoader = useLoading();
    let loader = useLoader.show({
        container: this.$refs.formContainer
    });

    axios.get(import.meta.env.VITE_URL_GET_BANK, {params: {'rn': this.fields.routing_number}}).then((response) => {

        const data = response.data
        if (data.code === 200) {
            this.fields.bank_name = data.customer_name;
            this.fields.bank_phone = data.telephone.replace(/-/g, '');
            this.checkRoutingNumber(data);
        } else {
            this.fields.bank_name = null;
            this.fields.bank_phone = null;
            document.getElementById('invalid-routing_number').textContent = data.message === 'not found' ? 'Not found' : data.message;
            document.getElementById('invalid-routing_number').classList.remove('d-none');
        }
        loader.hide();
    }).catch((error) => {
        console.error(error);
    });
}

export function payFrequencyWatcher() {
    this.nextPayDayWatcher();
}

export function disableNextPayDay(date) {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (yesterday > date) {
        return true;
    }
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
}

export function disableSecondPayDay(date) {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (yesterday > date) {
        return true;
    }
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
}

export function onlyDigitsKeypress(event) {
    if (event.key) {
        if (event.key === 'Backspace' || event.key === 'Tab' || event.ctrlKey) {
            return;
        }
        if (event.key.match(/[^0-9]/g)) {
            event.preventDefault();
        }
    }
}

export function visibilityChangeListener() {
    if (document.visibilityState === "visible") {
        clearInterval(this.intervalCheckDecision);
        this.sendRequestCheckStatusDecision(this);
        this.intervalCheckDecision = setInterval(() => {
            this.sendRequestCheckStatusDecision(this);
        }, import.meta.env.VITE_DELAY_STATUS_DECISION_CHECK * 1000)
    }
}

const rawDelayEnv = parseFloat(import.meta.env.VITE_DELAY_STATUS_DECISION_CHECK);
const delayMilliseconds = (!isNaN(rawDelayEnv) && rawDelayEnv > 0) ? rawDelayEnv * 1000 : 5000; // Default to 5 seconds if invalid

console.log('Setting up timeout loop to call sendRequestCheckStatusDecision every', delayMilliseconds, 'ms');
let timeoutCheckDecisionId;
// Clear any existing timeout with this ID to prevent multiple loops running
if (timeoutCheckDecisionId) {
    clearTimeout(timeoutCheckDecisionId);
    console.log('Cleared previous timeoutCheckDecisionId.');
}

export function checkStatusLoop(vueComponent) {
    const vue = vueComponent || this;
    try {
        console.log('Timeout loop: Calling sendRequestCheckStatusDecision...');
        sendRequestCheckStatusDecision(vue); // Execute your main function
    } catch (error) {
        console.error('Error within timeout loop executing sendRequestCheckStatusDecision:', error);
    }

    timeoutCheckDecisionId = setTimeout(() => checkStatusLoop(vue), delayMilliseconds);
    console.log('Next check scheduled with timeout ID:', timeoutCheckDecisionId);
}


export function sendRequestCheckStatusDecision(vue) {
    // If called as a method on a Vue component, use 'this' as the Vue component
    vue = vue || this;

    console.log('sendRequestCheckStatusDecision');

    if (globalParams.aid_verified) {
        if (vue.fieldsToReapplyPubId && vue.fieldsToReapplyPubId.request_id && vue.fieldsToReapplyPubId.lead_type) {
            vue.fields.request_id = vue.fieldsToReapplyPubId.request_id
            vue.fields.lead_type = vue.fieldsToReapplyPubId.lead_type
        }
    }
    axios
        .post(import.meta.env.VITE_API_CHECK_STATUS_DECISION, {
            email: vue.fields.email,
            click_id: vue.fields.click_id,
            request_id: vue.fields.request_id,
            lead_type: vue.fields.lead_type,
        })
        .then((response) => {
            if (response.data.message !== 'No data found') {
                clearInterval(vue.intervalCheckDecision);
                document.removeEventListener("visibilitychange", vue.visibilityChangeListener);
                vue.$refs.WaitingPage.stopTimer(() => {
                    vue.$cookies.remove('request_id'); // user will be redirected if response.data.message !== 'No data found', can remove('request_id')
                    vue.submitSuccess(response)
                });
            }
            if (response.data.timeout === 1) {
                vue.saveVariable(response);
                window.onbeforeunload = null;
                window.location.href = '/reject';
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

export function removeCookies(with_get_params = true) {
    this.$cookies.remove('requestedamount');
    this.$cookies.remove('customerDataMain');
    this.$cookies.remove('customerState');
    if (with_get_params) {
        this.$cookies.remove('click_id');
        this.$cookies.remove('offer_params');
        this.$cookies.remove('sub_ids');
        this.$cookies.remove('visit');
        this.$cookies.remove('click');
    }
}

function checkDecisionByRequestId(vue) {
    axios.get(import.meta.env.VITE_API_CHECK_DECISION, {
        params: {
            request_id: globalParams.request_id,
        }
    }).then((response) => {
        if (response.data.status) {
            window.location.href = import.meta.env.VITE_MARK_REDIRECTED_LINK + '?id=' + response.data.decision_id + '&request_id_mark=1' + '&waiting_redirect_decision=1';
        }
    }).catch((error) => {
        console.error(error);
    });
}


